import { useState, useEffect } from "react";
import axiosInstance from "../axiosInstance";

export const useRequestPriority = (requestProgressId, persona) => {
  const [data, setData] = useState({ priority: null, remainingDays: null });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPriority = async () => {
      if (!requestProgressId) return;
      setIsLoading(true);
      const baseUrl = persona === "customer"
        ? "/api/requests-progress/priority/enduser"
        : "/api/requests-progress/priority";
        console.log("baseUrl =>", baseUrl);
      try {
        const response = await axiosInstance.get(`${baseUrl}/${requestProgressId}`);
        const { priority, remainingDays } = response.data || {};
        setData({ priority, remainingDays: remainingDays });
      } catch (err) {
        console.error("Failed to fetch request priority", err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPriority();
  }, [requestProgressId, persona]);

  return { ...data, isLoading, error };
}; 